import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Tablet = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M3.5 4.038C3.5 1.843 5.595.42 7.709.42h28.582c2.114 0 4.209 1.423 4.209 3.618v36.764c0 2.195-2.095 3.618-4.209 3.618H7.709c-2.118 0-4.209-1.44-4.209-3.618V4.038Zm4.209-1.523c-1.381 0-2.111.868-2.111 1.523v36.764c0 .644.734 1.523 2.111 1.523h28.582c1.382 0 2.112-.868 2.112-1.523V4.038c0-.655-.73-1.523-2.112-1.523H7.709Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M8.017 33.664c0-.578.47-1.047 1.048-1.047h25.87a1.048 1.048 0 1 1 0 2.095H9.065c-.579 0-1.048-.469-1.048-1.048ZM20.224 38.372c0-.579.47-1.048 1.049-1.048h1.454a1.048 1.048 0 1 1 0 2.095h-1.454c-.58 0-1.049-.469-1.049-1.047Z"
  })));
});
Tablet.displayName = 'Tablet';
Tablet.defaultProps = {
  'aria-label': 'Tablet'
};
export default Tablet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Tablet.js
// module id = 3930
// module chunks = 11